import {PartnerRewardPointsMigrationDetailsApiDto} from "../../api/model/rest";

export default class PartnerRewardPointsMigrationDetails {
	constructor(public readonly status: string,
		public readonly running: boolean,
		public readonly totalPartners: number,
		public readonly completedPartners: number,
		public readonly failedPartners: number) {}

	public static fromJson(json: PartnerRewardPointsMigrationDetailsApiDto): PartnerRewardPointsMigrationDetails {
		return new PartnerRewardPointsMigrationDetails(json.status, json.running, json.stats.totalPartners, json.stats.completedPartners,
			json.stats.failedPartners);
	}
}
